export enum Concat {
    And,
    Or
}
